import {
  time,
  events,
  encrypt,
  Entity,
  coreEngine,
} from "@dinahmoe/dmafjs-core";

class StateController extends Entity {
  namespace = "control:stateController";

  init(node) {
    node.props.states.forEach(createStatesMapping.bind(this));

    function createStatesMapping(state) {
      state.uid = state.uid || encrypt.generateUid();
      state.inEvents.forEach((inEvent) =>
        events.addAction(
          inEvent,
          this.dispatchStateEvent.bind(this, node, state.uid)
        )
      );
    }
  }

  dispatchStateEvent(node, stateUid) {
    updateStatesUids.call(this, stateUid);
    dispatchStateEvent.call(this, stateUid);

    function updateStatesUids(stateUid) {
      if (node.props.currentStateUid) {
        coreEngine.update({
          uid: node.uid,
          key: "previousStateUid",
          value: node.props.currentStateUid,
        });
      }
      coreEngine.update({
        uid: node.uid,
        key: "currentStateUid",
        value: stateUid,
      });
    }

    function dispatchStateEvent(stateUid) {
      node.props.states
        .filter((state) => state.uid === stateUid)
        .forEach((state) =>
          this.dispatch(state.outEvent, time.current, { stateUid })
        );
    }
  }
}

const stateController = new StateController();
export { stateController, StateController };
